/**
 * @generated SignedSource<<66e035a89af61266231e9923cbdd8f81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type betQuery$variables = {};
export type betQuery$data = {
  readonly bets: {
    readonly sportBets: ReadonlyArray<{
      readonly gameId: string;
      readonly gameProvider: string;
      readonly currency: string;
      readonly virtualId: number;
      readonly finished: boolean;
      readonly bets: ReadonlyArray<number>;
      readonly win: number | null;
      readonly btcBet: number | null;
      readonly btcWin: number | null;
      readonly multiplier: number;
      readonly meta: any | null;
      readonly insertedAt: string;
      readonly user: {
        readonly uuid: string | null;
        readonly name: string;
        readonly hasProfileImage: boolean;
      };
    }>;
    readonly highrollers: ReadonlyArray<{
      readonly gameId: string;
      readonly gameProvider: string;
      readonly currency: string;
      readonly virtualId: number;
      readonly finished: boolean;
      readonly bets: ReadonlyArray<number>;
      readonly win: number | null;
      readonly btcBet: number | null;
      readonly btcWin: number | null;
      readonly multiplier: number;
      readonly meta: any | null;
      readonly insertedAt: string;
      readonly normalizedGame: {
        readonly label: string;
        readonly gameId: string;
        readonly provider: string | null;
      } | null;
      readonly user: {
        readonly uuid: string | null;
        readonly name: string;
        readonly hasProfileImage: boolean;
      };
    }>;
    readonly biggestWins: ReadonlyArray<{
      readonly gameId: string;
      readonly gameProvider: string;
      readonly currency: string;
      readonly virtualId: number;
      readonly finished: boolean;
      readonly bets: ReadonlyArray<number>;
      readonly win: number | null;
      readonly btcBet: number | null;
      readonly btcWin: number | null;
      readonly multiplier: number;
      readonly meta: any | null;
      readonly insertedAt: string;
      readonly normalizedGame: {
        readonly label: string;
        readonly gameId: string;
        readonly provider: string | null;
      } | null;
      readonly user: {
        readonly uuid: string | null;
        readonly name: string;
        readonly hasProfileImage: boolean;
      };
    }>;
    readonly biggestWinsGlobal: ReadonlyArray<{
      readonly gameId: string;
      readonly gameProvider: string;
      readonly currency: string;
      readonly virtualId: number;
      readonly finished: boolean;
      readonly bets: ReadonlyArray<number>;
      readonly win: number | null;
      readonly btcBet: number | null;
      readonly btcWin: number | null;
      readonly multiplier: number;
      readonly meta: any | null;
      readonly insertedAt: string;
      readonly normalizedGame: {
        readonly label: string;
        readonly gameId: string;
        readonly provider: string | null;
      } | null;
      readonly user: {
        readonly uuid: string | null;
        readonly name: string;
        readonly hasProfileImage: boolean;
      };
    }>;
    readonly recent: ReadonlyArray<{
      readonly gameId: string;
      readonly gameProvider: string;
      readonly currency: string;
      readonly virtualId: number;
      readonly finished: boolean;
      readonly bets: ReadonlyArray<number>;
      readonly win: number | null;
      readonly btcBet: number | null;
      readonly btcWin: number | null;
      readonly multiplier: number;
      readonly meta: any | null;
      readonly insertedAt: string;
      readonly normalizedGame: {
        readonly label: string;
        readonly gameId: string;
        readonly provider: string | null;
      } | null;
      readonly user: {
        readonly uuid: string | null;
        readonly name: string;
        readonly hasProfileImage: boolean;
      };
    }>;
  } | null;
};
export type betQuery = {
  variables: betQuery$variables;
  response: betQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gameId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gameProvider",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "virtualId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finished",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bets",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "win",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "btcBet",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "btcWin",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "multiplier",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insertedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "BetUser",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasProfileImage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "NormalizedGame",
    "kind": "LinkedField",
    "name": "normalizedGame",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v12/*: any*/)
],
v14 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BetSummary",
    "kind": "LinkedField",
    "name": "bets",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GameBet",
        "kind": "LinkedField",
        "name": "sportBets",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GameBet",
        "kind": "LinkedField",
        "name": "highrollers",
        "plural": true,
        "selections": (v13/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GameBet",
        "kind": "LinkedField",
        "name": "biggestWins",
        "plural": true,
        "selections": (v13/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GameBet",
        "kind": "LinkedField",
        "name": "biggestWinsGlobal",
        "plural": true,
        "selections": (v13/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GameBet",
        "kind": "LinkedField",
        "name": "recent",
        "plural": true,
        "selections": (v13/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "betQuery",
    "selections": (v14/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "betQuery",
    "selections": (v14/*: any*/)
  },
  "params": {
    "cacheID": "ea0355d54cd6ff13ebcf328af0992db3",
    "id": null,
    "metadata": {},
    "name": "betQuery",
    "operationKind": "query",
    "text": "query betQuery {\n  bets {\n    sportBets {\n      gameId\n      gameProvider\n      currency\n      virtualId\n      finished\n      bets\n      win\n      btcBet\n      btcWin\n      multiplier\n      meta\n      insertedAt\n      user {\n        uuid\n        name\n        hasProfileImage\n      }\n    }\n    highrollers {\n      gameId\n      gameProvider\n      currency\n      virtualId\n      finished\n      bets\n      win\n      btcBet\n      btcWin\n      multiplier\n      meta\n      insertedAt\n      normalizedGame {\n        label\n        gameId\n        provider\n      }\n      user {\n        uuid\n        name\n        hasProfileImage\n      }\n    }\n    biggestWins {\n      gameId\n      gameProvider\n      currency\n      virtualId\n      finished\n      bets\n      win\n      btcBet\n      btcWin\n      multiplier\n      meta\n      insertedAt\n      normalizedGame {\n        label\n        gameId\n        provider\n      }\n      user {\n        uuid\n        name\n        hasProfileImage\n      }\n    }\n    biggestWinsGlobal {\n      gameId\n      gameProvider\n      currency\n      virtualId\n      finished\n      bets\n      win\n      btcBet\n      btcWin\n      multiplier\n      meta\n      insertedAt\n      normalizedGame {\n        label\n        gameId\n        provider\n      }\n      user {\n        uuid\n        name\n        hasProfileImage\n      }\n    }\n    recent {\n      gameId\n      gameProvider\n      currency\n      virtualId\n      finished\n      bets\n      win\n      btcBet\n      btcWin\n      multiplier\n      meta\n      insertedAt\n      normalizedGame {\n        label\n        gameId\n        provider\n      }\n      user {\n        uuid\n        name\n        hasProfileImage\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "adda7080ec912a2f624bc095875cffa5";

export default node;
